var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBook = function SvgBook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.797 17.031a.703.703 0 0 0 .703-.703V2.734c0-1.163-.946-2.109-2.11-2.109H2.61C1.445.625.5 1.571.5 2.735v14.53c0 1.164.946 2.11 2.11 2.11h12.187a.703.703 0 0 0 0-1.406H2.609a.704.704 0 0 1-.703-.703v-.235h12.89ZM4.953 5.313h6.094a.703.703 0 1 1 0 1.406H4.953a.703.703 0 1 1 0-1.407Z",
    fill: "#BFC3D1"
  })));
};

export default SvgBook;